import { OptionGroupDto } from '../../generated-api';
import { CartAdditionOption } from '../../types/cart';

export const hasFulfilledMaxMinSelectionForRequiredOptionGroup = (
  addedOptions: CartAdditionOption[],
  requiredOptionGroup: OptionGroupDto
) => {
  const totalQuantity = addedOptions.reduce((acc, option) => {
    if (requiredOptionGroup.options.some((opt) => opt.optionId === option.option.optionId)) {
      return acc + option.quantity;
    }
    return acc;
  }, 0);

  if (requiredOptionGroup.minSelection === 0 && requiredOptionGroup.maxSelection === 0) {
    return totalQuantity > 0;
  }

  return totalQuantity >= requiredOptionGroup.minSelection && totalQuantity <= requiredOptionGroup.maxSelection;
};

export const hasFulfilledMaxMinSelectionForRequiredOptionGroups = (
  addedOptions: CartAdditionOption[],
  requiredOptionGroups: OptionGroupDto[]
) => {
  return requiredOptionGroups.every((requiredOptionGroup) =>
    hasFulfilledMaxMinSelectionForRequiredOptionGroup(addedOptions, requiredOptionGroup)
  );
};

export const isRequiredHandled = (optionGroup: OptionGroupDto, addedOptions: CartAdditionOption[]) => {
  return hasFulfilledMaxMinSelectionForRequiredOptionGroup(addedOptions, optionGroup);
};

export const calculateAddedOptionGroups = (addedOptions: CartAdditionOption[], optionGroups: OptionGroupDto[]) => {
  const addedOptionIds = addedOptions.map((option) => option.option.optionId);

  return optionGroups.filter((optionGroup) =>
    optionGroup.options.flatMap((option) => option.optionId).some((optionId) => addedOptionIds.includes(optionId))
  );
};

export const calculateNotAddedOptionGroups = (
  requiredOptionGroups: OptionGroupDto[],
  addedRequiredOptionGroups: OptionGroupDto[]
) => {
  return requiredOptionGroups
    .map((optionGroup) => optionGroup.optionGroupId)
    .filter(
      (optionGroupId) =>
        !addedRequiredOptionGroups.map((optionGroup) => optionGroup.optionGroupId).includes(optionGroupId)
    );
};

export const handleMissingCustomizationScroll = (
  requiredOptionGroups: OptionGroupDto[],
  addedRequiredOptionGroups: OptionGroupDto[]
) => {
  const firstMissingRequiredOptionGroup = calculateNotAddedOptionGroups(
    requiredOptionGroups,
    addedRequiredOptionGroups
  )[0];

  if (firstMissingRequiredOptionGroup) {
    const customizationPopup = document.getElementsByClassName('dialog-content')[0] as HTMLElement;
    const firstElement = document.getElementById(firstMissingRequiredOptionGroup);

    if (customizationPopup && firstElement) {
      customizationPopup.scrollTo({
        top: firstElement.offsetTop - customizationPopup.offsetTop,
        behavior: 'smooth',
      });
    }
  }
};
